import React from "react";
import { Link } from "react-router-dom";
import HomeData from "../../../data/home.json";
function ServiceTwoArea() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <div className="service-section pt-10 pb-120">
        <div className="container">
          <div className="row mb-4 pb-3 d-flex justify-content-lg-start justify-content-center align-items-center">
            <div className="col-lg-8  text-lg-start text-center">
              <div
                className="section-title2 wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h3 className="cusm-front" >Development Lifecycle</h3>
                {/* <h2 className="cusm-front ">We Shape The Perfect Solutions</h2> */}
              </div>
            </div>
 
          </div>
          <div className="row d-flex justify-content-center g-4">
          <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                {/* <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center"> */}
                  <div className="s-content pt-4 ">

                    <h4 className="cusm-front">
                      <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                       Discovery
                      </Link>
                    </h4>
                    <p className="solution_para_home solution_para_home_deploy  pt-4">
                    This is where we work closely with our clients to understand their business needs, goals, and challenges. We gather requirements, analyze existing systems, and identify potential roadblocks. This stage sets the foundation for the entire project and ensures that everyone is on the same page. 
                    </p>

                  </div>
                  <span />

                {/* </div> */}
          </div>
          <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
             <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                         <img  style={{height:"100%", width:"100%"}} className='dlp-dis' src={process.env.PUBLIC_URL + "/images/banner/Group 22.png"} alt="images" />
                      </Link>
          </div>
  {/* vis */}
      <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
             <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                         <img className='dlp-vis'  style={{height:"100%", width:"100%"}} src={process.env.PUBLIC_URL + "/images/banner/Group 18.png"} alt="images" />
                      </Link>
          </div>
          <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                {/* <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center"> */}
                  <div className="s-content pt-4 ">

                    <h4 className="cusm-front">
                      <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                      Visualization

                      </Link>
                    </h4>
                    <p className="solution_para_home solution_para_home_deploy  pt-4">
                    Once we have a clear understanding of the project requirements, we begin to create a visual representation of the solution. This includes wireframes, mockups, and prototypes. We involve our clients in this process to ensure that the final product aligns with their vision and meets their expectations. 
                    </p>

                  </div>
                  <span />

                {/* </div> */}
          </div>
          {/* Prepare to Launch */}
          <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                {/* <div className="service-item light-mode hover-btn d-flex justify-content-between align-items-center"> */}
                  <div className="s-content pt-4">

                    <h4 className="cusm-front">
                      <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                       Prepare to Launch 
                      </Link>
                    </h4>
                    <p className="solution_para_home solution_para_home_deploy  pt-4">
                    This is the final stage of our Development Lifecycle where we test, refine and prepare for launch. Our Quality Assurance team thoroughly tests the software to ensure that it is stable, secure, and functional. We work with our clients to ensure a smooth transition from development to production, providing training, and support as needed. Once the software is launched, we continue to monitor and maintain it to ensure its continued success. 
                    </p>

                  </div>
                  <span />

                {/* </div> */}
          </div>
          <div
                className="col-xl-6 col-lg-4 col-md-6 col-sm-8"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
             <Link
                        to={`${process.env.PUBLIC_URL}/service-details`}
                        onClick={scrollTop}
                      >
                         <img className='.dlp-lanuch'  style={{height:"100%", width:"100%"}} src={process.env.PUBLIC_URL + "/images/banner/Group 21.png"} alt="images" />
                      </Link>
          </div>

          </div>

        </div>
        <div className="row mt-3">
          <div className="col-lg-6"></div>
          <div
            className="col-lg-4 text-lg-end text-center wow animate fadeInDown"
            data-wow-duration="1.5s"
            data-wow-delay="0.6s"
          >
        
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceTwoArea;
